/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Checkboxes_Onlyhistoricallows2Inputs */

const id_search_checkboxes_onlyhistoricallows2 = /** @type {(inputs: Search_Checkboxes_Onlyhistoricallows2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanya harga terendah historis`)
};

const ms_search_checkboxes_onlyhistoricallows2 = /** @type {(inputs: Search_Checkboxes_Onlyhistoricallows2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanya paras rendah sejarah`)
};

const da_search_checkboxes_onlyhistoricallows2 = /** @type {(inputs: Search_Checkboxes_Onlyhistoricallows2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kun historiske lavpunkter`)
};

const de_search_checkboxes_onlyhistoricallows2 = /** @type {(inputs: Search_Checkboxes_Onlyhistoricallows2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur historische Tiefststände`)
};

const en_us2_search_checkboxes_onlyhistoricallows2 = /** @type {(inputs: Search_Checkboxes_Onlyhistoricallows2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only historical lows`)
};

const es_es2_search_checkboxes_onlyhistoricallows2 = /** @type {(inputs: Search_Checkboxes_Onlyhistoricallows2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo mínimos históricos`)
};

const es_mx2_search_checkboxes_onlyhistoricallows2 = /** @type {(inputs: Search_Checkboxes_Onlyhistoricallows2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo mínimos históricos`)
};

const fil_search_checkboxes_onlyhistoricallows2 = /** @type {(inputs: Search_Checkboxes_Onlyhistoricallows2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga historical lows lang`)
};

const fr_search_checkboxes_onlyhistoricallows2 = /** @type {(inputs: Search_Checkboxes_Onlyhistoricallows2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uniquement les minimas historiques`)
};

const it_search_checkboxes_onlyhistoricallows2 = /** @type {(inputs: Search_Checkboxes_Onlyhistoricallows2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo minimi storici`)
};

const hu_search_checkboxes_onlyhistoricallows2 = /** @type {(inputs: Search_Checkboxes_Onlyhistoricallows2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Csak történelmi mélypontok`)
};

const nl_search_checkboxes_onlyhistoricallows2 = /** @type {(inputs: Search_Checkboxes_Onlyhistoricallows2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alleen historische dieptepunten`)
};

const no_search_checkboxes_onlyhistoricallows2 = /** @type {(inputs: Search_Checkboxes_Onlyhistoricallows2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bare historiske bunnpunkter`)
};

const pl_search_checkboxes_onlyhistoricallows2 = /** @type {(inputs: Search_Checkboxes_Onlyhistoricallows2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tylko historyczne minima`)
};

const pt_br2_search_checkboxes_onlyhistoricallows2 = /** @type {(inputs: Search_Checkboxes_Onlyhistoricallows2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apenas mínimos históricos`)
};

const pt_search_checkboxes_onlyhistoricallows2 = /** @type {(inputs: Search_Checkboxes_Onlyhistoricallows2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apenas mínimos históricos`)
};

const ro_search_checkboxes_onlyhistoricallows2 = /** @type {(inputs: Search_Checkboxes_Onlyhistoricallows2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doar minime istorice`)
};

const fi_search_checkboxes_onlyhistoricallows2 = /** @type {(inputs: Search_Checkboxes_Onlyhistoricallows2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vain historialliset pohjahinnat`)
};

const sv_search_checkboxes_onlyhistoricallows2 = /** @type {(inputs: Search_Checkboxes_Onlyhistoricallows2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endast historiska bottenpriser`)
};

const vi_search_checkboxes_onlyhistoricallows2 = /** @type {(inputs: Search_Checkboxes_Onlyhistoricallows2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chỉ mức thấp lịch sử`)
};

const tr_search_checkboxes_onlyhistoricallows2 = /** @type {(inputs: Search_Checkboxes_Onlyhistoricallows2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yalnızca tarihi düşükler`)
};

const cs_search_checkboxes_onlyhistoricallows2 = /** @type {(inputs: Search_Checkboxes_Onlyhistoricallows2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pouze historická minima`)
};

const bg_search_checkboxes_onlyhistoricallows2 = /** @type {(inputs: Search_Checkboxes_Onlyhistoricallows2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Само исторически минимуми`)
};

const ru_search_checkboxes_onlyhistoricallows2 = /** @type {(inputs: Search_Checkboxes_Onlyhistoricallows2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Только исторические минимумы`)
};

const uk_search_checkboxes_onlyhistoricallows2 = /** @type {(inputs: Search_Checkboxes_Onlyhistoricallows2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тільки історичні мінімуми`)
};

const ar_search_checkboxes_onlyhistoricallows2 = /** @type {(inputs: Search_Checkboxes_Onlyhistoricallows2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أدنى الأسعار التاريخية فقط`)
};

const hi_search_checkboxes_onlyhistoricallows2 = /** @type {(inputs: Search_Checkboxes_Onlyhistoricallows2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`केवल ऐतिहासिक निम्नतम`)
};

const th_search_checkboxes_onlyhistoricallows2 = /** @type {(inputs: Search_Checkboxes_Onlyhistoricallows2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เฉพาะราคาต่ำสุดในประวัติศาสตร์`)
};

const ja_search_checkboxes_onlyhistoricallows2 = /** @type {(inputs: Search_Checkboxes_Onlyhistoricallows2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`過去最安値のみ`)
};

const zh_cn2_search_checkboxes_onlyhistoricallows2 = /** @type {(inputs: Search_Checkboxes_Onlyhistoricallows2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仅限历史最低价`)
};

const zh_hant1_search_checkboxes_onlyhistoricallows2 = /** @type {(inputs: Search_Checkboxes_Onlyhistoricallows2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`僅限歷史最低價`)
};

const ko_search_checkboxes_onlyhistoricallows2 = /** @type {(inputs: Search_Checkboxes_Onlyhistoricallows2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`역대 최저가만`)
};

/**
* | output |
* | --- |
* | "Only historical lows" |
*
* @param {Search_Checkboxes_Onlyhistoricallows2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const search_checkboxes_onlyhistoricallows2 = /** @type {((inputs?: Search_Checkboxes_Onlyhistoricallows2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Checkboxes_Onlyhistoricallows2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_search_checkboxes_onlyhistoricallows2(inputs)
	if (locale === "ms") return ms_search_checkboxes_onlyhistoricallows2(inputs)
	if (locale === "da") return da_search_checkboxes_onlyhistoricallows2(inputs)
	if (locale === "de") return de_search_checkboxes_onlyhistoricallows2(inputs)
	if (locale === "en-US") return en_us2_search_checkboxes_onlyhistoricallows2(inputs)
	if (locale === "es-ES") return es_es2_search_checkboxes_onlyhistoricallows2(inputs)
	if (locale === "es-MX") return es_mx2_search_checkboxes_onlyhistoricallows2(inputs)
	if (locale === "fil") return fil_search_checkboxes_onlyhistoricallows2(inputs)
	if (locale === "fr") return fr_search_checkboxes_onlyhistoricallows2(inputs)
	if (locale === "it") return it_search_checkboxes_onlyhistoricallows2(inputs)
	if (locale === "hu") return hu_search_checkboxes_onlyhistoricallows2(inputs)
	if (locale === "nl") return nl_search_checkboxes_onlyhistoricallows2(inputs)
	if (locale === "no") return no_search_checkboxes_onlyhistoricallows2(inputs)
	if (locale === "pl") return pl_search_checkboxes_onlyhistoricallows2(inputs)
	if (locale === "pt-BR") return pt_br2_search_checkboxes_onlyhistoricallows2(inputs)
	if (locale === "pt") return pt_search_checkboxes_onlyhistoricallows2(inputs)
	if (locale === "ro") return ro_search_checkboxes_onlyhistoricallows2(inputs)
	if (locale === "fi") return fi_search_checkboxes_onlyhistoricallows2(inputs)
	if (locale === "sv") return sv_search_checkboxes_onlyhistoricallows2(inputs)
	if (locale === "vi") return vi_search_checkboxes_onlyhistoricallows2(inputs)
	if (locale === "tr") return tr_search_checkboxes_onlyhistoricallows2(inputs)
	if (locale === "cs") return cs_search_checkboxes_onlyhistoricallows2(inputs)
	if (locale === "bg") return bg_search_checkboxes_onlyhistoricallows2(inputs)
	if (locale === "ru") return ru_search_checkboxes_onlyhistoricallows2(inputs)
	if (locale === "uk") return uk_search_checkboxes_onlyhistoricallows2(inputs)
	if (locale === "ar") return ar_search_checkboxes_onlyhistoricallows2(inputs)
	if (locale === "hi") return hi_search_checkboxes_onlyhistoricallows2(inputs)
	if (locale === "th") return th_search_checkboxes_onlyhistoricallows2(inputs)
	if (locale === "ja") return ja_search_checkboxes_onlyhistoricallows2(inputs)
	if (locale === "zh-CN") return zh_cn2_search_checkboxes_onlyhistoricallows2(inputs)
	if (locale === "zh-Hant") return zh_hant1_search_checkboxes_onlyhistoricallows2(inputs)
	return ko_search_checkboxes_onlyhistoricallows2(inputs)
});
export { search_checkboxes_onlyhistoricallows2 as "search.checkboxes.onlyHistoricalLows" }